import React from "react";
import { Formik } from "formik";
import PropTypes from "prop-types";

import { StyledForm } from "./styles";

export const AppForm = ({ initialValues, validationSchema, onSubmit, children, style }) => {
  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <StyledForm onSubmit={handleSubmit} style={style}>
          {children}
        </StyledForm>
      )}
    </Formik>
  );
};

AppForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  validationSchema: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
  style: PropTypes.object,
};
